import {useDispatch} from "react-redux";

import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useSubscribeToNewsletter} from "../../newsletter/hooks/useSubscribeToNewsletter";
import {useAppSelector} from "../../store/hooks";
import {getUserSourceDisplay} from "../../tracking/tracking_utils/user_source";
import {useGetUserProfileQuery} from "../../user/api/get_user_profile";
import {HomeMatchBasicPreferencesFlow} from "../../user/components/home_match_basic_preferences_flow/HomeMatchBasicPreferencesFlow";
import {UserPreferencesUpdateDataModal} from "../../user/components/preferences/UserPreferencesUpdateDataModal";
import {UserPhoneVerification} from "../../user/components/UserPhoneVerification";
import {UserUpdatePhoneNumberModal} from "../../user/components/UserUpdatePhoneNumberModal";
import {type HomeMatchBasicPreferencesFlowCompletionReason} from "../../user/types/HomeMatchBasicPreferencesFlowTypes";
import {closeFlow, nextStep, RegistrationFlowStep} from "../state/registration_flow_slice";
import {AuthModalVariant} from "./auth_modal/AuthModalHeaderVariants";
import {AuthModalRegistrationFlow} from "./AuthModalRegistrationFlow";

export const RegistrationFlow = () => {
    const dispatch = useDispatch();
    const flowState = useAppSelector((state) => state.registrationFlow);
    const {hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();
    const {saveNewsletterSearchData, subscribeToNotifications} = useSubscribeToNewsletter();
    const {data: userProfile} = useGetUserProfileQuery();
    const homeMatchBasicEventCategory = flowState.gtmSourceSection || (flowState.userSource ? getUserSourceDisplay(flowState.userSource) : "");

    if (!flowState.isActive) {
        return null;
    }

    const handlers = {
        onNextStep: () => {
            dispatch(nextStep({hasCompleteProfile, hasPhoneVerified}));
        },
        onCloseFlow: () => {
            if (flowState.titleVariant === AuthModalVariant.NOTIFICATION_SUBSCRIPTION && userProfile) {
                subscribeToNotifications(userProfile);
            }
            dispatch(closeFlow());
        }
    };

    const onPreferencesSuccess = (reason?: HomeMatchBasicPreferencesFlowCompletionReason) => {
        if (flowState.titleVariant === AuthModalVariant.NOTIFICATION_SUBSCRIPTION && flowState.preferences) {
            const {regions, rooms, price} = flowState.preferences;
            saveNewsletterSearchData({
                ...(regions?.length ? {search: {regions}} : {}),
                ...(rooms ? {rooms} : {}),
                ...(price ? {price: {upper: price}} : {})
            });
        }

        if (reason === "homeMatchSkipped") {
            handlers.onNextStep();
            return;
        }

        handlers.onCloseFlow();
    };

    return (
        <>
            {flowState.currentStep === RegistrationFlowStep.REGISTRATION && <AuthModalRegistrationFlow />}
            {flowState.currentStep === RegistrationFlowStep.PHONE_COMPLETION && <UserUpdatePhoneNumberModal isOpen onSuccess={handlers.onNextStep} />}
            {flowState.currentStep === RegistrationFlowStep.PHONE_VERIFICATION && <UserPhoneVerification isOpen onSuccess={handlers.onNextStep} />}
            {flowState.currentStep === RegistrationFlowStep.PREFERENCES && (
                <HomeMatchBasicPreferencesFlow
                    isOpen
                    source="survey"
                    initialStep="survey"
                    defaultHomeMatchBasicConsent={false}
                    propertyId={flowState.propertyId}
                    offerId={flowState.offerId}
                    trackingContext={{
                        eventName: "modal_post_sign_up",
                        eventCategory: homeMatchBasicEventCategory,
                        sourceModal: "modal_post_sign_up"
                    }}
                    onComplete={onPreferencesSuccess}
                />
            )}
            {flowState.currentStep === RegistrationFlowStep.UPDATED_PREFERENCES && <UserPreferencesUpdateDataModal isOpen onClose={handlers.onCloseFlow} />}
        </>
    );
};
import {useDispatch} from "react-redux";

import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useSubscribeToNewsletter} from "../../newsletter/hooks/useSubscribeToNewsletter";
import {useAppSelector} from "../../store/hooks";
import {getUserSourceDisplay} from "../../tracking/tracking_utils/user_source";
import {useGetUserProfileQuery} from "../../user/api/get_user_profile";
import {HomeMatchBasicPreferencesFlow} from "../../user/components/home_match_basic_preferences_flow/HomeMatchBasicPreferencesFlow";
import {UserPreferencesUpdateDataModal} from "../../user/components/preferences/UserPreferencesUpdateDataModal";
import {UserPhoneVerification} from "../../user/components/UserPhoneVerification";
import {UserUpdatePhoneNumberModal} from "../../user/components/UserUpdatePhoneNumberModal";
import {type HomeMatchBasicPreferencesFlowCompletionReason} from "../../user/types/HomeMatchBasicPreferencesFlowTypes";
import {closeFlow, nextStep, RegistrationFlowStep} from "../state/registration_flow_slice";
import {AuthModalVariant} from "./auth_modal/AuthModalHeaderVariants";
import {AuthModalRegistrationFlow} from "./AuthModalRegistrationFlow";

export const RegistrationFlow = () => {
    const dispatch = useDispatch();
    const flowState = useAppSelector((state) => state.registrationFlow);
    const {hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();
    const {saveNewsletterSearchData, subscribeToNotifications} = useSubscribeToNewsletter();
    const {data: userProfile} = useGetUserProfileQuery();
    const homeMatchBasicEventCategory = flowState.gtmSourceSection || (flowState.userSource ? getUserSourceDisplay(flowState.userSource) : "");

    if (!flowState.isActive) {
        return null;
    }

    const handlers = {
        onNextStep: () => {
            dispatch(nextStep({hasCompleteProfile, hasPhoneVerified}));
        },
        onCloseFlow: () => {
            if (flowState.titleVariant === AuthModalVariant.NOTIFICATION_SUBSCRIPTION && userProfile) {
                subscribeToNotifications(userProfile);
            }
            dispatch(closeFlow());
        }
    };

    const onPreferencesSuccess = (reason?: HomeMatchBasicPreferencesFlowCompletionReason) => {
        if (flowState.titleVariant === AuthModalVariant.NOTIFICATION_SUBSCRIPTION && flowState.preferences) {
            const {regions, rooms, price} = flowState.preferences;
            saveNewsletterSearchData({
                ...(regions?.length ? {search: {regions}} : {}),
                ...(rooms ? {rooms} : {}),
                ...(price ? {price: {upper: price}} : {})
            });
        }

        if (reason === "homeMatchSkipped") {
            handlers.onNextStep();
            return;
        }

        handlers.onCloseFlow();
    };

    return (
        <>
            {flowState.currentStep === RegistrationFlowStep.REGISTRATION && <AuthModalRegistrationFlow />}
            {flowState.currentStep === RegistrationFlowStep.PHONE_COMPLETION && <UserUpdatePhoneNumberModal isOpen onSuccess={handlers.onNextStep} />}
            {flowState.currentStep === RegistrationFlowStep.PHONE_VERIFICATION && <UserPhoneVerification isOpen onSuccess={handlers.onNextStep} />}
            {flowState.currentStep === RegistrationFlowStep.PREFERENCES && (
                <HomeMatchBasicPreferencesFlow
                    isOpen
                    source="survey"
                    initialStep="survey"
                    defaultHomeMatchBasicConsent={false}
                    propertyId={flowState.propertyId}
                    offerId={flowState.offerId}
                    trackingContext={{
                        eventName: "modal_post_sign_up",
                        eventCategory: homeMatchBasicEventCategory,
                        sourceModal: "modal_post_sign_up"
                    }}
                    onComplete={onPreferencesSuccess}
                />
            )}
            {flowState.currentStep === RegistrationFlowStep.UPDATED_PREFERENCES && <UserPreferencesUpdateDataModal isOpen onClose={handlers.onCloseFlow} />}
        </>
    );
};
